import React from 'react';
import moment from 'moment';

export const defaultShortcuts = [
  {
    label: <strong>Today</strong>,
    hotkey: 'O',
    date: moment(),
  },
  {
    label: (
      <span>
        End of previous
        <strong> month</strong>
      </span>
    ),
    hotkey: 'M',
    date: moment(moment()).subtract(1, 'months').endOf('month'),
  },
  {
    label: (
      <span>
        End of previous
        <strong> quarter</strong>
      </span>
    ),
    hotkey: 'Q',
    date: moment(moment()).subtract(1, 'quarters').endOf('quarter'),
  },
  {
    label: (
      <span>
        End of previous
        <strong> year</strong>
      </span>
    ),
    hotkey: 'Y',
    date: moment(moment()).subtract(1, 'years').endOf('year'),
  },
];

export const defaultMonths = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
